var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Loading'),_c('NavBar'),_c('div',{staticClass:"nj-views"},[_c('div',{staticClass:"nj-view-container"},[_c('router-view')],1)]),_c('div',{staticClass:"nj-version"},[_vm._v(_vm._s(_vm.version))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }